import { useState } from 'react'

import { Container } from 'components/container'
import {
  CloseButton,
  Consent,
  Fieldset,
  Input,
  Row,
  Section,
  StyledForm,
  SubmitButton,
  TextContent,
  Title,
} from './styled'

export const Subscribe = () => {
  const [isChecked, setChecked] = useState(false)
  const [isConsentOpen, setConsentOpen] = useState(false)

  return (
    <Section>
      <Container>
        <TextContent>
          <p>
            «Орел и решка» начинает «Новую жизнь»! Теперь ведущие не просто
            заглядывают в самые интересные, красивые и удивительные уголки
            планеты. Они примеряют города и страны на себя и пытаются понять — а
            можно ли здесь остаться?
          </p>

          <p>
            Правила неизменны: у одного ведущего бюджет в 100 долларов, другой —
            покоряет новые места с безлимитной картой. «Орел и решка. Новая
            жизнь» — это вызов современным реалиям, когда не знаешь, где
            окажешься завтра.
          </p>
        </TextContent>
        <StyledForm
          action="https://rferl.us10.list-manage.com/subscribe/post?u=3de062b009896941d3ae1c478&amp;id=bee54bfa32&amp;v_id=170&amp;f_id=0079c2e1f0"
          method="post"
          name="mc-embedded-subscribe-form"
          target="_blank"
        >
          <Row>
            <Title>Подпишись на&nbsp;нашу&nbsp;рассылку</Title>
            <Input
              type="email"
              name="EMAIL"
              className="required email"
              id="mce-EMAIL"
              required
              placeholder="твоя электронная почта"
            />
            <SubmitButton
              type="submit"
              value="Подпишись"
              name="subscribe"
              disabled={!isChecked}
            />
          </Row>
          <Fieldset name="interestgroup_field">
            <label className="checkbox subfield">
              <input
                type="checkbox"
                id="gdpr_318"
                name="gdpr[318]"
                value="Y"
                className="av-checkbox"
                checked={isChecked}
                onChange={evt => setChecked(evt.target.checked)}
              />
              Настоящим я даю согласие Votvot на использование моего адреса
              электронной почты для отправки мне выбранных информационных писем.
            </label>
          </Fieldset>
        </StyledForm>

        {isConsentOpen && (
          <Consent>
            <CloseButton type="button" onClick={() => setConsentOpen(false)}>
              <svg viewBox="0 0 37 36">
                <path
                  fill="#fff"
                  d="M36.7 35 19.2 17.5 36 .7l-.7-.7-16.8 16.8L1.7 0 1 .7l16.8 16.8L.3 35l.7.7 17.5-17.5L36 35.7z"
                />
              </svg>
            </CloseButton>
            <div>
              <h3>Правила защиты персональных данных</h3>
              <p>
                Votvot признает за пользователями интернета право на тайну
                личной информации и неконтролируемый доступ к интернету во всем
                его объеме. В ходе предоставления информационных услуг в сети
                интернет, мы собираем о наших пользователях данные двух видов:
                адрес электронной почты, указанный пользователем при подписке на
                материалы Votvot, и обобщенные статистические данные о
                посещаемости сайта.
              </p>
              <h3>Адреса электронной почты</h3>
              <p>
                Чтобы подписаться на новостные рассылки Votvot, необходимо
                предоставить адрес электронной почты. Votvot ни при каких
                обстоятельствах не передаст эти данные третьей стороне. Списки
                подписчиков не используются ни для какой иной цели, кроме
                новостных рассылок. Подписчик может отказаться от получения
                рассылки в любой момент; соответствующие инструкции приведены в
                рассылаемых материалах и на нашем сайте. При возникновении
                проблем, связанных с отказом от рассылки, пользователи могут
                обратиться за консультацией к нашим сотрудникам по электронной
                почте, указанной в рассылке.
              </p>
            </div>
          </Consent>
        )}
      </Container>
    </Section>
  )
}
